import { PatchConversationsApiResponse } from 'core_main/api/conversations/types';
import { DescribeConversationCallbackResponse } from './types';

export const createUpdateConversationCallbackResponse = (
  response: PatchConversationsApiResponse,
): DescribeConversationCallbackResponse => {
  const { attributes, id } = response.data;
  const custom = attributes?.custom;

  return {
    conversationId: id,
    custom,
  };
};
